import { createFileRoute } from '@tanstack/react-router';
import { SwHub } from '@/features/smart-working/SwHub';

export const Route = createFileRoute('/_app/smart-working/')({ component: SwHub });

// Modello HR v1 JSON:API con state-machine (identico a Leave). Desktop e mobile usano
// lo stesso hub; il vecchio planner mobile/desktop su endpoint legacy è stato ritirato
// perché il BE ha rimosso PATCH /api/smart-working/{id}/approve (workflow endpoints).
